// src/app/auth/auth.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { DataserviceService } from './dataservice.service';
import { isCompanyAdminUser } from './utils/company-admin.util';
import { firstValueFrom, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private dataService: DataserviceService
  ) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    const token = localStorage.getItem('access_token');
    if (!token) {
      return this.router.parseUrl('/signin');
    }

    let user = JSON.parse(localStorage.getItem('user') || '{}');

    try {

      if(user?.active_portal_id) {
        this.dataService.getData(`portals/selected-portal/${user?.active_portal_id}`)
          .subscribe(({
            next: (res: any) => {
              localStorage.removeItem('user')
              const updatedUser = {
                ...user,
                ...res,
                id: user.id,
                active_portal_id: user?.active_portal_id,
                active_company_name: user?.active_company_name|| 'Unknown'
              };
              localStorage.removeItem('user')
              localStorage.setItem('user', JSON.stringify(updatedUser));

              user = updatedUser;

              this.checkOnboarding(user, state)

            }}))
      }else {
        this.checkOnboarding(user, state)
      }
    } catch {
      // ignore fetch errors, fall back to stored user
    }



    const companyAdminOnly = route.data['companyAdminOnly'];
    if (companyAdminOnly && !isCompanyAdminUser(user)) {
      this.router.navigate(['/unauthorized']);
      return false;
    }

    const superAdminOnly = route.data['superAdminOnly'];
    if (superAdminOnly && !user?.super_admin) {
      this.router.navigate(['/unauthorized']);
      return false;
    }

    // Check for required permissions
    const requiredPermission = route.data['permission'];
    if (requiredPermission) {
      if (user.super_admin) {
        return true;
      }
      const isImpersonating = localStorage.getItem('isImpersonating') === 'true';
      if (isImpersonating) {
        return true;
      }
      const hasPermission = user?.permissions?.some(
        (p: any) => p.name === requiredPermission
      );

      if (!hasPermission) {
        return this.router.parseUrl('/unauthorized');
      }
    }

    return true;
  }

checkOnboarding(user: any, state: any): boolean | UrlTree {
  // 1. Safety check: If no user or data, allow them to proceed (or redirect to login)
  if (!user || !('onboardingCompleted' in user)) {
    return true; 
  }

  const isOnboardingComplete = user.onboardingCompleted;
  const targetUrl = (state.url || '').split('?')[0];

  const onboardingAllowed = [
    '/signin', '/sign-in', '/login', '/phone-login', '/onboarding', '/quiz-taking'
  ];

  // 2. If onboarding is NOT complete
  if (!isOnboardingComplete) {
    const isAllowed = onboardingAllowed.some(path => targetUrl.startsWith(path));
    
    // Redirect if they are trying to go somewhere they shouldn't
    if (!isAllowed) {
      return this.router.parseUrl('/onboarding');
    }
  }

  // 3. In all other cases (onboarding is complete OR they are on an allowed page)
  return true;
}
}
